import type { Position } from '@/types/generated/common/trading'

/**
 * Equality over only the fields the option chain renders from a position
 * (accountId, symbol, side, quantity). Every positions flush hands back fresh
 * objects carrying a new mark price/PnL; comparing just these fields lets a
 * selectAtom keep the previous array — and with it every OptionRow's memo —
 * until a position actually opens, closes, flips or resizes.
 */
export function sameOptionPositionFields(
  a: ReadonlyArray<Position>,
  b: ReadonlyArray<Position>
): boolean {
  if (a === b) return true
  if (a.length !== b.length) return false
  for (let i = 0; i < a.length; i++) {
    const x = a[i]
    const y = b[i]
    if (
      x.accountId !== y.accountId ||
      x.symbol !== y.symbol ||
      x.side !== y.side ||
      x.quantity !== y.quantity
    ) {
      return false
    }
  }
  return true
}
